import { DayView } from '@devexpress/dx-react-scheduler-material-ui';

import { useContext, useRef, useState } from 'react';
import { TSelectedDetail } from '../../../../../../../../Types/MasterDetailTypes';
import { RutinSettingsContext } from '../../../../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { AktivitetTypCellMeny } from '../../../../AktivitetTypCellMeny';
import { SchedulerContext } from '../../SchedulerContext';
import { nyAktivitetInitialValues } from '../Utils/NyAktivitetInitialValues';
import { ViewDbSettingsContext } from '../ViewDbSettingsContext';

export const DayViewTimeTableCellComponent = (
  props: DayView.TimeTableCellProps
) => {
  const schedulerContext = useContext(SchedulerContext);
  const rutinSettingsContext = useContext(RutinSettingsContext);
  const resourceContext = useContext(ViewDbSettingsContext);
  const [showAktivitetTypCellMeny, setShowAktivitetTypCellMeny] =
    useState(false);
  const onSelectDetail = (id: TSelectedDetail) => {
    schedulerContext?.onSelectDetail?.(id) ?? '';
  };
  const ref = useRef<HTMLElement | null>(null);

  const handleDoubleClick = () => {
    if (
      props.groupingInfo?.[0].id ===
      resourceContext?.loggedInUserResource?.resName
    ) {
      if (resourceContext?.loggedInUserResource?.kanBoka) {
        setShowAktivitetTypCellMeny(true);
        schedulerContext.setNyAktivitetInitialValues(
          nyAktivitetInitialValues(
            props.startDate,
            props.endDate,
            true,
            props.groupingInfo?.[0].id,
            schedulerContext,
            rutinSettingsContext
          )
        );
      }
    } else if (props.groupingInfo?.[0].id) {
      if (
        resourceContext?.resources?.find(
          res => res.resName === props.groupingInfo?.[0].id && res.kanBoka
        )
      ) {
        setShowAktivitetTypCellMeny(true);
        schedulerContext.setNyAktivitetInitialValues(
          nyAktivitetInitialValues(
            props.startDate,
            props.endDate,
            true,
            props.groupingInfo?.[0].id,
            schedulerContext,
            rutinSettingsContext
          )
        );
      }
    } else {
      if (
        resourceContext?.resources?.find(res => res.kanBoka) ||
        resourceContext?.loggedInUserResource?.kanBoka
      ) {
        setShowAktivitetTypCellMeny(true);
        schedulerContext.setNyAktivitetInitialValues(
          nyAktivitetInitialValues(
            props.startDate,
            props.endDate,
            true,
            props.groupingInfo?.[0].id,
            schedulerContext,
            rutinSettingsContext
          )
        );
      }
    }
  };

  return (
    <>
      <DayView.TimeTableCell
        {...props}
        onDoubleClick={() => {
          handleDoubleClick();
        }}
        onFocus={() => {
          schedulerContext.setNyAktivitetInitialValues(
            nyAktivitetInitialValues(
              props.startDate,
              props.endDate,
              true,
              props.groupingInfo?.[0].id,
              schedulerContext,
              rutinSettingsContext
            )
          );
        }}
        onBlur={() => {}}
      >
        <span ref={ref}>{props.children}</span>
      </DayView.TimeTableCell>
      <AktivitetTypCellMeny
        anchorEl={ref.current}
        open={showAktivitetTypCellMeny}
        onClose={() => {
          setShowAktivitetTypCellMeny(false);
        }}
        onSelectDetail={onSelectDetail}
      />
    </>
  );
};
